import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { Helmet } from 'react-helmet';
import { Typography } from 'enova-frontend-components';

import DismissableInfoBox from '../../../components/dismissableInfoBox';
import BuildingFilterProvider from '../../../hooks/useBuildingFilter/provider';
import { useUser } from '../../../hooks/useUser';
import Buildings from '../buildings';
import { queryKeys } from '../../../utils/react-query';
import { getBuildingList } from '../../../services/api';
import { MainScreenTab } from '../../../utils/navigation';

export const BuildingsTabContent = () => {
  const { t } = useTranslation();
  const { user } = useUser();

  const {
    error: buildingsError,
    isLoading: buildingsLoading,
    data: buildings,
    refetch: refreshBuildings
  } = useQuery([queryKeys.buildingList], () => getBuildingList());

  return (
    <React.Fragment>
      <Helmet title={t(`mainScreen.tab.boliger`, { context: user?.type })} />

      <Typography variant="h2" mb={3}>
        {t(`mainScreen.tab.boliger`, {
          context: user?.type
        })}
      </Typography>

      <DismissableInfoBox inline={false} localStorageKey={user?.userId} title={t('mainScreen.buildings.info.title')}>
        {t('mainScreen.buildings.info.content')}
      </DismissableInfoBox>

      <BuildingFilterProvider
        buildingList={{
          buildings,
          buildingsError: !!buildingsError,
          buildingsLoading,
          refreshBuildings
        }}
      >
        <Buildings tab={MainScreenTab.BUILDINGS} />
      </BuildingFilterProvider>
    </React.Fragment>
  );
};
